import { render, staticRenderFns } from "./OpportunitiesDetails.vue?vue&type=template&id=b3f0e962&scoped=true&"
import script from "./OpportunitiesDetails.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f0e962",
  null
  
)

export default component.exports